export default __webpack_public_path__ + "static/media/life-ring-solid.37e7b5c6.svg";